<template>
  <div>
    <Card shadow>
      <Row :gutter="24">
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">操作模块:</span>
            <Select
              v-model="table.params.opmode"
              filterable
              placeholder="操作模块"
              @on-change="updatePlat"
            >
              <Option
                v-for="(item, index) in this.select.module_list"
                :value="item"
                :label="item"
                :key="index"
              >
                {{ item }}
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">操作人ID:</span>
            <Input
              v-model="table.params.opuser"
              placeholder="操作人ID"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span style="width: 140px">操作人账户:</span>
            <Input
              v-model="table.params.opname"
              placeholder="操作人账户"
              clearable
            ></Input>
          </label>
        </Col>
      </Row>

      <Row :gutter="24" style="margin-top: 12px">
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">操作人IP:</span>
            <Input
              v-model="table.params.opip"
              placeholder="操作人IP"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="8">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">时间范围:</span>
            <DatePicker
              type="daterange"
              v-model="table.params.dataTime"
              placeholder="时间"
              :options="dateOptions"
              style="width: 100%"
            ></DatePicker>
          </label>
        </Col>
        <Button type="primary" @click.native="searchData()">查询</Button>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
      :max-height="tableMaxHeight"
      ref="tableRef"
    ></Table>
    <Page
      style="margin-top:10px;"
      :total="page.total"
      show-total
      :current="page.currentPage"
      :page-size-opts="page.pageSizes"
      :page-size="page.pageSize"
      show-sizer
      @on-page-size-change="pageSizeChange"
      @on-change="pageChange"
    ></Page>
  </div>
</template>

<script>
// import MulReportHeader from './components/mul_report_header.vue';
import { TransTopReq } from '@/api/admin/risk'
import { QueryOperateLog } from '@/api/admin/permission'

import moment from 'moment'
// import { debug } from 'console';
export default {
  name: 'operateRecord',
  // components: { MulReportHeader },
  data() {
    return {
      tableMaxHeight: 0,
      loading: false,
      TransTopReqTimer: null,
      timestamp: 0,
      select: {
        module_list: [
          '盘口数据',
          '风控管理',
          '同步管理',
          '风控操作',
          '数据报表',
          '玩家管理',
          '用户管理'
        ],
        pack_list: []
      },
      all: {},
      //活动数据
      // GetZhuanPanActiveData
      table: {
        app_name: '',
        gp_name: '',
        params: {
          opmode: '',
          opip: '',
          opuser: '',
          opname: '',
          general_id: -1,
          platid: 0,
          app_id: 0,
          pack_no: -1,
          dataTime: [
            new Date(
              this.getCurrentZeroDay().getTime() - 6 * 24 * 60 * 60 * 1000
            ),
            this.getCurrentZeroDay()
          ]
        },
        data: [],
        columns: [
          this.getRenderColumn('opMode', '操作模块', '操作模块'),
          this.getRenderColumn('opUser', '操作人ID', '操作人ID'),
          this.getRenderColumn('opName', '操作人账户', '操作人账户'),
          this.getRenderColumn('opTime', '操作时间', '操作时间'),
          this.getRenderColumn('opIp', '操作人IP', '操作人IP'),
          this.getRenderColumn('opDesc', '操作描述', '操作描述')
          // this.getRenderColumn('new_ci_ri_pay_rate', '操作描述', '操作描述')
          // this.getRenderColumn('new_ci_ri_pay_ave_sum', '子游戏名称', '筛选时间内,商户或子商人均新增次日复充金额'),
          // this.getRenderColumn('new_three_pay_rate', '游戏人数(去重)', '筛选时间内,商户或子商户新增3日复充率'),
          // this.getRenderColumn('new_three_pay_ave_sum', '子游戏投注人数(去重)', '筛选时间内,商户或子商户人均新增3日复充金额'),
          // this.getRenderColumn('new_seven_pay_rate', '投注金额', '筛选时间内,商户或子商户新增7日复充率'),
          // this.getRenderColumn('new_seven_pay_ave_sum', '返奖金额', '筛选时间内,商户或子商户人均新增7日复充金额'),
          // this.getRenderColumn('pay_num', '游戏盈亏', '筛选时间内,商户或子商户转入人数'),
          // this.getRenderColumn('pay_sum', '游戏税收', '筛选时间内,商户或子商户转入金额'),
          // this.getRenderColumn('pay_ave', '盈亏/投注比(%)', '筛选时间内,商户或子商户人均转入金额'),
          // this.getRenderColumn('ci_ri_pay_rate', '历史总投注', '筛选时间内,商户或子商户次日复充率'),
          // this.getRenderColumn('ci_ri_pay_ave_sum', '历史总返奖', '筛选时间内,商户或子商户人均次日复充金额'),
          // this.getRenderColumn('three_pay_rate', '历史总盈亏', '筛选时间内,商户或子商户3日复充率'),
        ]
      },
      page: {
        total: 0,
        totalSum: 0,
        pageSize: 15,
        pageSizes: [15, 30, 45, 60],
        currentPage: 1
      }
    }
  },
  methods: {
    getRenderColumn(key, title, tip, width = 330) {
      return {
        key,
        width,
        align: 'center',
        resizable: true,
        renderHeader: h => this.renderHeader(h, title, tip),
        render: (h, params) => this.renderCol(h, params)
      }
    },
    //查询数据
    searchData() {
      let opstime = this.getSecond(this.table.params.dataTime[0])
      let opetime = this.getSecond(this.table.params.dataTime[1], false)
      QueryOperateLog({
        opip: this.table.params.opip,
        opuser: this.table.params.opuser ? Number(this.table.params.opuser) : 0,
        opmode: this.table.params.opmode,
        opname: this.table.params.opname,
        opstime,
        opetime,
        page: this.page.currentPage,
        limit: this.page.pagesize
      }).then(res => {
        if (res._param.list) {
          this.table.data = res._param.list
          this.page.total = res._param.total
        }
      })
    },
    renderCol(h, params) {
      let key = params.column.key

      let row = params.row
      if (key === 'opTime') {
        return h('span', moment(row[key] * 1000).format('YYYY-MM-DD HH:mm:ss'))
      }
      return h('span', row[key])
    },
    getTableLength() {
      return Math.max(this.table.data.length - 1, 1)
    },
    getAppList() {
      return this.app_list.filter(el => this.table.params.platid == el.platform)
    },
    getAppGenList() {
      let params = this.getTransTopParams('GetAppGeneralList', {
        app_id: this.table.params.app_id,
        platid: this.table.params.platid,
        stime: this.getSecond(this.table.params.dataTime[0]),
        etime: this.getSecond(this.table.params.dataTime[1], false),
        page: 1,
        limit: 10000,
        sort: 0,
        general: -1,
        pack_no: -1
      })
      this.select.general_list = []
      this.select.pack_list = []
      this.table.params.general_id = -1
      this.table.params.pack_no = -1
      TransTopReq(params).then(res => {
        this.select.general_list = res._param.general_list
        this.table.params.general_id = ''
        let params1 = this.copyData(params)
        params1.param._func = 'GetPackList'
        TransTopReq(params1).then(res => {
          this.select.pack_list = res._param.pack_list || []
        })
      })
    },
    updateGeneral() {
      this.table.params.pack_no = -1
    },
    getPackList() {
      return this.select.pack_list.filter(
        el => el.general == this.table.params.general_id
      )
    },
    //透传接口请求参数 请求方法 请求参数
    getTransTopParams(func, param) {
      return {
        mod: 'root',
        platid: param.platid,
        app_id: param.app_id,
        app_name: param.app_name,
        timestamp: param.timestamp,
        param: {
          _mod: 'manager',
          _func: func,
          _param: {
            ...param
          }
        }
      }
    },
    pageChange() {},
    limitChange() {},
    updatePlat() {
      this.table.params.app_id = this.getAppList()[0]['appid']
      this.getAppGenList()
    },
    initFunc() {
      this.table.params.platid = this.getinitPlatId()
      this.table.params.app_id = this.app_list.find(
        el => el.platform == this.table.params.platid
      )['appid']
      this.getAppGenList()
      this.searchData()
    },
    pageChange(page) {
      this.page.currentPage = page
      this.searchData()
    },
    pageSizeChange(size) {
      this.page.pageSize = size
      this.searchData()
    }
  },
  activated() {
    this.initFunc()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 240
  }
}
</script>

<style scoped lang="less"></style>
